import gql from 'graphql-tag'

const GET_BID_TYPES = gql`
  query bidTypes($tenantId: Int!, $offset: Int, $limit: Int) {
    bidTypes(tenantId: $tenantId, offset: $offset, limit: $limit) {
      total
      data {
        id
        bidType
      }
    }
  }
`

export { GET_BID_TYPES }
